import React, { useState } from 'react';
import axios from 'axios';
import { Input, Button, Typography, Modal, Form, Layout, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import logo from '../images/logo.png';
import { apiUrl } from './config';  // Modifica il percorso in base alla posizione del file
import RegistrationRequestModal from './RegistrationRequestModal';
import { Preferences } from '@capacitor/preferences';




const { Title, Text } = Typography;
const { Content } = Layout;

const Login = () => {
    const { setUser } = useUser();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [forgotEmail, setForgotEmail] = useState('');
    const [forgotMessage, setForgotMessage] = useState('');
    const [forgotMessageColor, setForgotMessageColor] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const res = await axios.post(`${apiUrl}/api/auth/login`, { email, password });
            const { user, token } = res.data;
    
            // Salva token e utente usando Preferences (su iOS, verrà salvato in UserDefaults)
            await Preferences.set({ key: 'token', value: token });
            await Preferences.set({ key: 'user', value: JSON.stringify(user) });
            
    
            setUser(user);
            message.success('Login avvenuto con successo!');
    
            // Naviga alla dashboard in base al ruolo
            if (user.isTemporaryPassword) {
                navigate('/change-password', { state: { email } });
            } else {
                navigate(user.role === 'trainer' ? '/trainer-dashboard' : '/cliente-dashboard');
            }
        } catch (error) {
            message.error('Credenziali errate!');
        }
    };
    
    

    const handleForgotPassword = async () => {
        try {
            const emailReset = forgotEmail.toLowerCase();
            await axios.post(`${apiUrl}/api/auth/forgot-password`, { email: emailReset });
            setForgotMessage('Email di recupero inviata correttamente.');
            setForgotMessageColor('green');
        } catch (error) {
            setForgotMessage('Errore nell\'invio dell\'email. Prova a controllare la mail inserita');
            setForgotMessageColor('red');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    // Stili in linea per il layout
    const layoutStyle = {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--sfondo)',
        overflow: 'hidden',
    };

    const contentStyle = {
        width: '100%',
        maxWidth: '600px',
        padding: '10px',
        textAlign: 'center'
    };

    const logoStyle = {
        display: 'block',
        margin: '0 auto 30px',
        width: '100%',
        maxWidth: '200px',
        height: 'auto',
    };

    const titleStyle = {
        color: 'var(--primario)',
        fontFamily: 'AKU E KAMU, sans-serif',
        fontSize: '2rem',
    };

    const buttonStyle = {
        backgroundColor: 'var(--primario)',
        borderColor: 'var(--primario)',
    };

    const forgotPasswordTextStyle = {
        cursor: 'pointer',
        display: 'block',
        textAlign: 'center',
        color: 'var(--primario)',
        fontSize: '16px',
        fontFamily: 'Neue Kaine, sans-serif',
    };
    

    return (
        <Layout style={layoutStyle}>
            <Content style={contentStyle}>
                <img src={logo} alt="FitLab Logo" style={logoStyle} />

                <Title level={2} style={titleStyle}>Benvenuto in FitLab</Title>

                <Form layout="vertical">
                    <Form.Item label="Email">
                        <Input value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Password">
                        <Input.Password
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={handleLogin} block style={buttonStyle}>
                            Accedi
                        </Button>
                    </Form.Item>
                </Form>

                <Text
                    style={forgotPasswordTextStyle}
                    onClick={() => setOpenModal(true)}
                >
                    Hai dimenticato la password?
                </Text>

                <Modal
                    title="Recupero Password"
                    open={openModal}
                    getContainer={document.body}
                    onOk={handleForgotPassword}
                    onCancel={() => setOpenModal(false)}
                    okText="Invia"
                    cancelText="Chiudi"
                    centered
                    className="custom-modal"
                >
                    <Form layout="vertical">
                        <Form.Item label="Email per il recupero">
                            <Input
                                placeholder="Inserisci la tua email"
                                value={forgotEmail}
                                onChange={(e) => setForgotEmail(e.target.value)}
                            />
                        </Form.Item>
                    </Form>
                    {forgotMessage && (
                        <Text style={{ color: forgotMessageColor }}>{forgotMessage}</Text>
                    )}
                </Modal>
                <RegistrationRequestModal />
            </Content>
        </Layout>
    );
};

export default Login;
